export default {
  title: '无访问权限',
  description: '您没有权限访问此页面。如需开通，请联系管理员分配相应操作权限。',
  back: '返回工作台'
}
